// The save scope from 03a09048. A two-paper or Pearson sitting saves the
// part's own questions, including nothing when that part has not loaded.
// Any other sitting still falls back to every loaded question when the
// part's list is empty.
export function questionsForPartSave(byPaper, scoped, allQuestions) {
  return byPaper || scoped.length ? scoped : allQuestions;
}
